import cn from 'classnames'
import React from 'react'

//

import ButtonNew from '../ButtonNew/ButtonNew'

const DesktopFilters = ({ handleOnCategoryClick, categories }) => {
  return (
    <div className="c-blogFilters__container-desktop">
      <div className="c-blogFilters__wrapper-desktop l-container:10/12">
        {categories.map((category) => (
          <ButtonNew
            key={category.id}
            classes={cn('c-blogFilters__button', category.selected && 'active')}
            buttonProps={{ onClick: () => handleOnCategoryClick(category.id) }}
            size="md"
          >
            {category.name}
          </ButtonNew>
        ))}
      </div>
    </div>
  )
}

export default DesktopFilters
